import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import * as AppBar from '../../Constants/AppBar';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AppsIcon from '@material-ui/icons/Apps';
import SignInButton from '../SignInButton';
import { useDispatch, useSelector } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import ABar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { Tooltip } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CorgisLogo from '../../icons/CorgisLogo';
import CustomTempDrawer from './CustomTempDrawer';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { resetAssetData } from '../../redux/actions/assetsAction';
import AssetReportingBtn from './AssetReportingBtn';

//This is a react functional component for rendering Mini variant drawer from Material UI components
//Using Styled components using Hooks API
// const drawerWidth = 150;
const activeStyle = {
	borderRadius: 'unset',
	borderBottom: '0.2rem solid #0042c2',
	backgroundColor: 'rgba(0,0,0,0.25)',
};
// Declaring the left top menu items with all required props as an object
const leftTopMenuItems = [
	{
		key: AppBar.Search,
		primaryTxt: AppBar.Search,
		navLinkTo: AppBar.Search_Root_NavLink_To,
		alterNativeActivePaths: [
			AppBar.Search_Root_NavLink_To,
			AppBar.Results_NavLink_To,
			AppBar.Search_Alt_NavLink_To,
			AppBar.ManageAssets_NavLink_To,
			AppBar.ManageProducts_NavLink_To,
		],
		requiresAuth: true,
	},
	{
		key: AppBar.uploadCsv,
		primaryTxt: AppBar.uploadCsv,
		navLinkTo: AppBar.Create_UploadCsv_NavLink_To,
		alterNativeActivePaths: [AppBar.Create_UploadCsv_NavLink_To],
		requiresAuth: true,
	},
	{
		key: AppBar.manualEntry,
		primaryTxt: AppBar.manualEntry,
		navLinkTo: AppBar.Create_ManualEntry_NavLink_To,
		alterNativeActivePaths: [AppBar.Create_ManualEntry_NavLink_To],
		requiresAuth: true,
	},
];
// Declaring all right top menu items with required props as an object.
const rightTopMenuItems = [
	{
		label: 'Notifications',
		key: AppBar.Notifications,
		icon: <NotificationsIcon style={{ color: 'white' }} />,
		requiresAuth: true,
	},
	{
		label: 'User Name',
		key: AppBar.UserName,
		icon: <PersonIcon style={{ color: 'white' }} />,
		requiresAuth: true,
	},
	{
		label: 'LIL Apps',
		key: AppBar.LILApps,
		icon: <AppsIcon style={{ color: 'white' }} />,
		requiresAuth: true,
	},
];
//Style components with Hooks
const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexGrow: 1,
	},
	toolbar: { alignItems: 'stretch' },
	left: {
		order: 1,
		alignItems: 'stretch',
	},
	right: {
		order: 2,
		alignItems: 'stretch',
	},
	branding: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		textDecoration: 'none',
		minWidth: '10rem',
	},
	divider: {
		backgroundColor: 'rgba(0,0,0,0.4)',
		minWidth: '0.1rem',
	},
	button: {
		display: 'flex',
		justifyContent: 'flex-start',
		minWidth: '10rem',
		color: 'white',
	},
	activeStyle: activeStyle,
}));

//IsLeftNavItemActive returns a bool value if the current url match is part of alternativeActive paths for left nav list item.
const IsLeftNavItemActive = (alterNativeActivePaths, location) => {
	let locationPathname = location.pathname;
	// if location path name has manage assets / manage products / search results route path removing param from the path name.
	if (
		location.pathname.includes(AppBar.ManageAssets_NavLink_To) ||
		location.pathname.includes(AppBar.ManageProducts_NavLink_To) ||
		location.pathname.includes(AppBar.Results_NavLink_To)
	) {
		const lastIndex = locationPathname.lastIndexOf('/');
		locationPathname = locationPathname.slice(0, lastIndex);
	}
	return alterNativeActivePaths.includes(locationPathname);
};

function MiniVariantDrawer() {
	const user = useSelector((state) => state?.user);
	const token = user?.token?.id_token;
	const userDisplayName = user?.displayName;
	const itemAuthFilter = (item) => token || !item.requiresAuth;
	const history = useHistory();
	const classes = useStyles();
	const location = useLocation();
	const dispatch = useDispatch();
	// State to track the destination clicked element URL to navigate from the unsaved data warning popup.
	const [navToDestUrl, setNavToDestUrl] = useState('');
	// Assets part of create asset workflow.
	const unSavedAssets = useSelector((state) => state.assets);
	// Drawer for unsaved assets warning when switching tabs between upload CSV and Manual Entry states and props.
	const [openDrawer, setDrawerOpen] = React.useState(false);
	const handleDrawerBtnClick = () => {
		// navigate user to clicked element, after confirmation from unsaved data dialog.
		history.push(navToDestUrl);
		setDrawerOpen(false);
		// resetting the unsaved assets.
		dispatch(resetAssetData());
	};
	// getting current active tab or nav item object name, to display it on the drawer when trying to navigate away from active tab when page has unsaved changes.
	const navItemObj = leftTopMenuItems.find((item) => item.navLinkTo === location.pathname);
	let navItemName = '';
	if (navItemObj) {
		navItemName = navItemObj.primaryTxt.toUpperCase();
	}
	const tempDrawerProps = {
		open: openDrawer,
		setOpen: setDrawerOpen,
		header: `EXIT ${navItemName}`,
		confirmationMessage:
			'Are you sure you want to leave? Any assets that you have started to create will not be saved and you will lose all progress.',
		primaryBtnStartIcon: <ExitToAppIcon />,
		primaryBtnTxt: `YES,EXIT ${navItemName}`,
		primaryButtonClick: handleDrawerBtnClick,
	};
	// Handle click event for menu items.
	const handleClick = (e) => {
		/* 
		unsaved data dialog should not be displayed if there is only one asset which has field (isAddedBySystem) as true
		which is added by the system automatically when landed on manual Entry page.
		*/
		if (unSavedAssets.length === 1 && unSavedAssets[0].isAddedBySystem === true) {
			return;
		} else if (unSavedAssets.length > 0) {
			const elm = e.currentTarget;
			// currentTarget to get the element that the event listener is attached to.
			// only trigger popup when switching between UploadCSV or Manual Entry when there is unsaved assets data.
			const urlSplitArr = elm.href.split('#');
			setNavToDestUrl(urlSplitArr[1]);
			setDrawerOpen(true);
			e.preventDefault();
			e.stopPropagation();
		}
	};
	//rendering left drawer menu individual element with required props
	let renderListItemIcon = (
		{ label, key, primaryTxt, icon, navLinkTo, alterNativeActivePaths }, //Alternative paths so that each nav link can be active on multiple state URL's
	) => {
		let item;

		if (navLinkTo) {
			item = (
				<Button
					key={key}
					component={NavLink}
					data-cy={key}
					id={key}
					to={navLinkTo}
					href={navLinkTo}
					onClick={handleClick}
					exact
					activeStyle={activeStyle}
					className={classes.button}
					isActive={() => IsLeftNavItemActive(alterNativeActivePaths, location)}
				>
					{primaryTxt}
				</Button>
			);
		} else {
			item = (
				<IconButton key={key} data-cy={key}>
					{icon}
				</IconButton>
			);
		}
		if (label) {
			// set label to user name if the menu item is UserName.
			if (key === AppBar.UserName) {
				label = userDisplayName;
			}
			item = (
				<Tooltip data-cy={key} key={key} title={label} aria-label={label} placement="bottom">
					{item}
				</Tooltip>
			);
		}
		return item;
	};
	return (
		<ABar className={classes.root} color="secondary" data-cy="app-Bar">
			<Toolbar className={classes.toolbar}>
				<Grid className={classes.left} container wrap="nowrap" justify="flex-start" alignItems="center">
					<Button
						className={classes.branding}
						key="Corgis"
						component={NavLink}
						onClick={handleClick}
						to={AppBar.Search_Root_NavLink_To}
						href={AppBar.Search_Root_NavLink_To}
						exact
					>
						<CorgisLogo size={24} />
					</Button>
					<Divider className={classes.divider} orientation="vertical" flexItem={true} />
					{leftTopMenuItems.filter(itemAuthFilter).map(renderListItemIcon)}
					<Divider className={classes.divider} orientation="vertical" flexItem={true} />
				</Grid>
				<Grid className={classes.right} container wrap="nowrap" justify="flex-end" alignItems="center">
					<AssetReportingBtn />
					{rightTopMenuItems.filter(itemAuthFilter).map(renderListItemIcon)}
					<SignInButton />
				</Grid>
			</Toolbar>
			<CustomTempDrawer {...tempDrawerProps}></CustomTempDrawer>
		</ABar>
	);
}

export default MiniVariantDrawer;
